import {ColonistMembershipType, ColonistOneTimePurchaseType, LobbyImage} from '@colonist/types'
import {ColonistMembershipProduct, MobileMembershipGiftIAPSKUIds, PerkAllColors, PerkAllExpansions, PerkAllMaps, PerkBasicReplay, PerkFullReplay, PerkNoAds, PerkRankedGames} from './ColonistMembershipProduct.ts'

export class ColonistGiftMembershipProduct extends ColonistMembershipProduct {
    static products: Map<ColonistMembershipType, ColonistMembershipProduct> = new Map()

    static override getAllMembershipProducts(): ColonistMembershipProduct[] {
        return Array.from(this.products.values())
    }

    static override initProducts(discordSKUIds: Record<string, string>): void {
        const giftPlusMonthlyProduct = new ColonistMembershipProduct({
            type: ColonistMembershipType.PlusMonthly,
            price: 899,
            discordSKUId: discordSKUIds.giftMembershipPlus,
            membershipTitle: {key: 'strings:storePage.membership.title.plus'},
            membershipColor: 'membership_type1',
            lobbyImage: LobbyImage.StoreMembershipPlus,
            perks: [new PerkRankedGames(), new PerkNoAds(), new PerkBasicReplay()],
            billedAnnually: false,
            bestValue: false,
            mobileIAPSKUId: MobileMembershipGiftIAPSKUIds.PlusMonthly,
            discount: 0,
            isActive: () => true,
        })
        giftPlusMonthlyProduct.oneTimePurchaseType = ColonistOneTimePurchaseType.GiftPlusMonthly
        this.products.set(ColonistMembershipType.PlusMonthly, giftPlusMonthlyProduct)

        const giftPremiumMonthlyProduct = new ColonistMembershipProduct({
            type: ColonistMembershipType.PremiumMonthly,
            price: 1899,
            discordSKUId: discordSKUIds.giftMembershipPremium,
            mobileIAPSKUId: MobileMembershipGiftIAPSKUIds.PremiumMonthly,
            membershipTitle: {key: 'strings:storePage.membership.title.premium'},
            membershipColor: 'membership_type2',
            lobbyImage: LobbyImage.StoreMembershipPremium,
            perks: [new PerkRankedGames(), new PerkNoAds(), new PerkFullReplay(), new PerkAllExpansions(), new PerkAllMaps()],
            billedAnnually: false,
            bestValue: true,
            discount: 0,
            isActive: () => true,
        })
        giftPremiumMonthlyProduct.oneTimePurchaseType = ColonistOneTimePurchaseType.GiftPremiumMonthly
        this.products.set(ColonistMembershipType.PremiumMonthly, giftPremiumMonthlyProduct)

        const giftEliteMonthlyProduct = new ColonistMembershipProduct({
            type: ColonistMembershipType.EliteMonthly,
            price: 2499,
            discordSKUId: discordSKUIds.giftMembershipElite,
            mobileIAPSKUId: MobileMembershipGiftIAPSKUIds.EliteMonthly,
            membershipTitle: {key: 'strings:storePage.membership.title.elite'},
            membershipColor: 'membership_type3',
            lobbyImage: LobbyImage.StoreMembershipElite,
            perks: [new PerkRankedGames(), new PerkNoAds(), new PerkFullReplay(), new PerkAllExpansions(), new PerkAllMaps(), new PerkAllColors()],
            billedAnnually: false,
            bestValue: false,
            discount: 0,
            isActive: () => true,
        })
        giftEliteMonthlyProduct.oneTimePurchaseType = ColonistOneTimePurchaseType.GiftEliteMonthly
        this.products.set(ColonistMembershipType.EliteMonthly, giftEliteMonthlyProduct)

        const giftPlusYearlyProduct = new ColonistMembershipProduct({
            type: ColonistMembershipType.PlusYearly,
            price: 8388,
            discordSKUId: discordSKUIds.giftMembershipPlusYearly,
            mobileIAPSKUId: MobileMembershipGiftIAPSKUIds.PlusYearly,
            membershipTitle: {key: 'strings:storePage.membership.title.plus'},
            membershipColor: 'membership_type1',
            lobbyImage: LobbyImage.StoreMembershipPlus,
            perks: [new PerkRankedGames(), new PerkNoAds(), new PerkBasicReplay()],
            billedAnnually: false,
            bestValue: false,
            discount: 24,
            isActive: () => true,
        })
        giftPlusYearlyProduct.oneTimePurchaseType = ColonistOneTimePurchaseType.GiftPlusYearly
        this.products.set(ColonistMembershipType.PlusYearly, giftPlusYearlyProduct)

        const giftPremiumYearlyProduct = new ColonistMembershipProduct({
            type: ColonistMembershipType.PremiumYearly,
            price: 17988,
            discordSKUId: discordSKUIds.giftMembershipPremiumYearly,
            mobileIAPSKUId: MobileMembershipGiftIAPSKUIds.PremiumYearly,
            membershipTitle: {key: 'strings:storePage.membership.title.premium'},
            membershipColor: 'membership_type2',
            lobbyImage: LobbyImage.StoreMembershipPremium,
            perks: [new PerkRankedGames(), new PerkNoAds(), new PerkFullReplay(), new PerkAllExpansions(), new PerkAllMaps()],
            billedAnnually: false,
            bestValue: true,
            discount: 48,
            isActive: () => true,
        })

        giftPremiumYearlyProduct.oneTimePurchaseType = ColonistOneTimePurchaseType.GiftPremiumYearly
        this.products.set(ColonistMembershipType.PremiumYearly, giftPremiumYearlyProduct)

        const giftEliteYearlyProduct = new ColonistMembershipProduct({
            type: ColonistMembershipType.EliteYearly,
            price: 23988,
            discordSKUId: discordSKUIds.giftMembershipEliteYearly,
            mobileIAPSKUId: MobileMembershipGiftIAPSKUIds.EliteYearly,
            membershipTitle: {key: 'strings:storePage.membership.title.elite'},
            membershipColor: 'membership_type3',
            lobbyImage: LobbyImage.StoreMembershipElite,
            perks: [new PerkRankedGames(), new PerkNoAds(), new PerkFullReplay(), new PerkAllExpansions(), new PerkAllMaps(), new PerkAllColors()],
            billedAnnually: false,
            bestValue: false,
            discount: 60,
            isActive: () => true,
        })

        giftEliteYearlyProduct.oneTimePurchaseType = ColonistOneTimePurchaseType.GiftEliteYearly
        this.products.set(ColonistMembershipType.EliteYearly, giftEliteYearlyProduct)
    }
}
